import { useState } from "react";
import { api, formatApiError } from "@/lib/api";

export const MoveCycleForm = ({ line, defaultMonth, onDone, onError, onCancel, label = "Move" }) => {
  const [month, setMonth] = useState(defaultMonth || "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const id = line.evaluation_id;
  async function save() {
    setBusy(true);
    try {
      const response = await api.post(`/evaluation-billing/${id}/cycle`, { cycle_month: month, note });
      onDone(`${line.student_initials} · ${line.evaluation_type} moved to the ${response.data.cycle_label} cycle.`);
    } catch (requestError) {
      onError(formatApiError(requestError));
    } finally {
      setBusy(false);
    }
  }
  return (
    <span className="billing-inline-form billing-move-form" data-testid={`move-cycle-form-${id}`}>
      <input type="month" value={month} data-testid={`move-cycle-month-${id}`} onChange={(e) => setMonth(e.target.value)} />
      <input placeholder="Why it moves (required)" value={note} data-testid={`move-cycle-note-${id}`} onChange={(e) => setNote(e.target.value)} />
      <button type="button" className="button button-secondary" disabled={busy || !month || note.trim().length < 3} data-testid={`move-cycle-save-${id}`} onClick={save}>{busy ? "Saving…" : label}</button>
      {onCancel && <button type="button" className="link-button" data-testid={`move-cycle-cancel-${id}`} onClick={onCancel}>Cancel</button>}
    </span>
  );
};

export const completedLabel = (line) => {
  const day = line.completed_on ? new Date(`${line.completed_on}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "—";
  const basis = line.report_external ? "external report" : line.billing?.cycle_basis === "provider_submission" ? "provider upload" : line.billing?.cycle_basis === "moved" ? "moved" : "";
  return { day, basis };
};
